import React, { useState } from 'react'
import { PiPhoneCallThin } from 'react-icons/pi';

export const CallButton = () => {
   
    return (
        <button className="flex items-center gap-4">
        <div className='flex items-center justify-center'>
            <PiPhoneCallThin  Call className='text-2xl md:text-3xl ' />
        </div>
        <div className=' text-base hidden md:block items-center'>
            <div className='flex items-center gap-1'>Trợ giúp?</div>
            <div className='font-bold hover:text-[--color-button-3] transition-all duration-150'>+ 0903.449.446</div>
        </div>
    </button>
    )
}
